<template>
  <div class="ui list">
    <div v-for="(item,index) in value" class="item"><a class="ui label">{{labelForItem(item)}}</a></div>
  </div>
</template>

<script>
  import {forOwn,isObject} from 'lodash'
    export default {
      name: "array-list-view",
      props:{
        prop:{
          type:Object,
          required:true
        },
        value:{
          type:Array,
          default:()=>[]
        },
      },
      methods:{
        labelForItem(item){
          if (isObject(item)){
            if (!this.prop.properties) return item.label;
            let label="";
            forOwn(this.prop.properties,(prop,propName)=>{
              label=label+(prop.title||propName)+": "+(isObject(item[propName])?item[propName].label:item[propName])+"; "
            })
            return label;
          }
          return item;
        }
      }
    }
</script>

<style scoped>

</style>
